<template>
  <div class="general-menu">
    <!-- Banner 图片 -->
    <div v-if="data.bannerImage" class="banner-section">
      <img :src="data.bannerImage" alt="Banner" class="banner-image">
    </div>

    <!-- 其他内容区域 -->
    <div v-if="hasOtherContent && !isListMenu && !isProductMenu" class="content-section">
      <!-- 如果有 HTML 内容，直接渲染 -->
      <div v-if="data.htmlContent" class="html-content" v-html="data.htmlContent"></div>

      <!-- 如果有其他字段，可以在这里扩展 -->
      <div v-if="data.title" class="title">{{ data.title }}</div>
      <div v-if="data.description" class="description">{{ data.description }}</div>
    </div>

    <!-- 列表显示（行业咨询/公司动态） -->
    <DynamicList v-if="isListMenu && data.menuCode" :menu-code="data.menuCode" :type="'88'" :status="2" :page-size="10" />
    <!-- 产品列表（产品中心下的子菜单） -->
    <ProductList v-if="isProductMenu && data.menuCode" :menu-code="data.menuCode" :parent-menu-id="data.parentMenuId" />
  </div>
</template>

<script>
import DynamicList from './DynamicList.vue'
import ProductList from './ProductList.vue'

export default {
  name: 'GeneralMenu',
  components: {
    DynamicList,
    ProductList
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    hasOtherContent () {
      return this.data.htmlContent || this.data.title || this.data.description
    },
    isListMenu () {
      // 判断是否是行业咨询或公司动态
      const menuName = (this.data.menuName || '').toLowerCase()
      return menuName.includes('行业咨询') || menuName.includes('公司动态')
    },
    isProductMenu () {
      // 判断是否是产品中心下的子菜单
      const parentName = (this.data.parentName || '').toLowerCase()
      const menuName = (this.data.menuName || '').toLowerCase()
      // 如果父菜单名称包含"产品中心"，或者是产品中心本身
      // 排除行业咨询和公司动态（它们使用 type 88）
      if (menuName.includes('行业咨询') || menuName.includes('公司动态')) {
        return false
      }
      return parentName.includes('产品中心') || menuName.includes('产品中心')
    }
  }
}
</script>

<style scoped>
.general-menu {
  width: 100%;
}

.banner-section {
  width: 100%;
  margin-bottom: 24px;
  height: 400px;
}

.banner-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.content-section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.html-content {
  line-height: 1.8;
  color: #333;
}

.html-content ::v-deep img {
  max-width: 100%;
  height: auto;
}

.html-content ::v-deep p {
  margin-bottom: 16px;
}

.html-content ::v-deep h1,
.html-content ::v-deep h2,
.html-content ::v-deep h3 {
  margin-top: 24px;
  margin-bottom: 16px;
  color: #333;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  text-align: center;
}

.description {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin-bottom: 24px;
}

/* 移动端 */
@media (max-width: 768px) {
  .banner-section {
    margin-bottom: 16px;
  }

  .content-section {
    padding: 0 16px;
  }

  .title {
    font-size: 24px;
  }

  .description {
    font-size: 14px;
  }
}
</style>
